<template>
  <div>
    <!-- <app-header @changed_corpus_id="forwardCorpusId"></app-header>
    <router-view :corpus_id="corpus_id"></router-view> -->

    <app-header
      id="headerFixed"
      @changed_corpus_id="forwardCorpusId"
      @changed_height="setContentMargin"
    ></app-header>

    <router-view
      id="appBody"
      v-bind:style="{ marginTop: margin + 'px' }"
      :corpus_id="corpus_id"
    ></router-view>

    <footer>
      <cookie-law
        message="We are using cookies to ensure you can access your documents and to enhance the user experience."
        buttonClass="btn btn-success"
        theme="base--rounded"
      ></cookie-law>
    </footer>
  </div>
</template>

<script>
// Imports
import header from "./components/header.vue";
import CookieLaw from "vue-cookie-law";

export default {
  components: {
    "app-header": header,
    CookieLaw,
  },
  data() {
    return {
      corpus_id: "",
      margin: 64,
    };
  },
  methods: {
    forwardCorpusId(corpus_id) {
      this.corpus_id = corpus_id;
    },
    setContentMargin(height) {
      this.margin = height + 8;
    },
  },
};
</script>

<style>
#headerFixed {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/App.vue